export default {
  authenticated(state) {
    return state.authenticated;
  }
};